/* Adds real flavor variants so Shopify manages pricing, tax and stock. */
if (!customElements.get('fp-box-builder')) {
  customElements.define('fp-box-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.cards = [...this.querySelectorAll('[data-flavor]')];
      this.quantities = new Map(this.cards.map(card => [card.dataset.id, 0]));
      this.submit = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.money = new Intl.NumberFormat(this.dataset.locale, {style: 'currency', currency: this.dataset.currency});
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled || this.busy) return;
        if (button === this.submit) { this.addBox(); return; }
        const card = button.closest('[data-flavor]');
        if (!card) return;
        const id = card.dataset.id, current = this.quantities.get(id);
        const next = current + (button.hasAttribute('data-plus') ? 1 : -1);
        if (next >= 0 && next <= this.limit(card)) {
          this.quantities.set(id, next);
          this.status.textContent = '';
          this.render();
        }
      });
      this.querySelector('[data-search]').addEventListener('input', event => {
        const query = event.target.value.trim().toLocaleLowerCase();
        this.cards.forEach(card => {card.hidden = !card.dataset.title.toLocaleLowerCase().includes(query);});
        this.querySelector('[data-empty]').hidden = this.cards.some(card => !card.hidden);
      });
      this.render();
    }
    limit(card) { return card.dataset.limit === "" ? Infinity : Number(card.dataset.limit); }
    count() { return [...this.quantities.values()].reduce((a,b) => a+b,0); }
    render() {
      const count = this.count();
      let price = 0;
      this.cards.forEach(card => {
        const quantity = this.quantities.get(card.dataset.id);
        price += quantity * Number(card.dataset.price);
        card.querySelector('[data-quantity]').textContent = quantity;
        card.querySelector('[data-minus]').disabled = this.busy || quantity === 0;
        card.querySelector('[data-plus]').disabled = this.busy || quantity >= this.limit(card);
      });
      this.querySelector('[data-count]').textContent = `${count}`;
      this.querySelector('[data-total]').textContent = this.money.format(price / 100);
      this.submit.disabled = this.busy || count < 4;
      this.submit.textContent = this.busy ? this.messages.adding : count >= 4 ? this.messages.add : this.messages.choose;
    }
    async request(path, body) {
      const response = await fetch(`${this.dataset.root}cart${path}.js`, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin',
        headers: {'Content-Type':'application/json', 'Accept':'application/json'},
        ...(body ? {body:JSON.stringify(body)} : {}), signal: AbortSignal.timeout(20000)
      });
      const data = await response.json();
      return {ok:response.ok, data};
    }
    async addBox() {
      if (this.busy || this.count() < 4) return;
      this.busy = true;
      this.render();
      const group = crypto.randomUUID();
      const items = [...this.quantities].filter(([,quantity]) => quantity > 0).map(([id,quantity]) => ({id:Number(id),quantity,properties:{Box:this.messages.box,'_fp_box':group}}));
      try {
        // An inventory error may still add some items. Always reconcile the cart.
        let uncertain = false;
        try { await this.request('/add', {items}); } catch (_) { uncertain = true; }
        const cart = await this.request('');
        if (!cart.ok || !Array.isArray(cart.data.items)) throw new Error('Cart could not be checked');
        const added = cart.data.items.filter(item => item.properties?._fp_box === group);
        const complete = added.length === items.length && items.every(item => added.some(line => line.variant_id === item.id && line.quantity === item.quantity));
        if (uncertain && !added.length) throw new Error('Add result is uncertain');
        if (complete) { window.location.assign(`${this.dataset.root}cart`); return; }
        if (added.length) {
          const rollback = await this.request('/update', {updates:Object.fromEntries(added.map(item => [item.key,0]))});
          if (!rollback.ok || rollback.data.items.some(item => item.properties?._fp_box === group)) throw new Error('Incomplete box could not be removed');
        }
        this.status.textContent = this.messages.partial;
        this.busy = false;
        this.render();
      } catch (_) {
        // Keep selection locked when the result is uncertain, preventing duplicate submissions.
        this.status.textContent = this.messages.error;
        this.querySelector('[data-review]').hidden = false;
        this.submit.textContent = this.messages.error;
      }
    }
  });
}
